import {initialize as initializeLocationPolicy, getLocationValue} from '../registration/registrationlocationpolicy.js';

window.Registration = {
    initializeLocationPolicy: initializeLocationPolicy,
    getLocationValue: getLocationValue,
};
